import { Button, DeleteIcon, Menu, MoreIcon, StopIcon, TransferIcon } from "melco-ui";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import {
    ControlcenterMelcoModelsHoop,
    // Drawer as DrawerType,
    // MelcoModelsUserSerialNumber,
    useConfirm,
} from "melco-shared-logic";
//import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useNavigate } from "react-router-dom";
import { useDeleteHoop } from "../../hooks/hoops/useDeleteHoop";

type HoopMoreActionButtonProps = {

    hoop?: ControlcenterMelcoModelsHoop | undefined;
};

export const HoopMoreActionButton: React.FC<
    HoopMoreActionButtonProps
> = ({ hoop }) => {
    const { t } = useTranslation();

    const navigate = useNavigate()
    // const { roles } = useRolesContext();
    const deleteHoop = useDeleteHoop(hoop?.cloud_id ?? undefined);
    const confirmDeleteHoop = useConfirm(
        async () => {


            const deleteHoopResponse = await deleteHoop();

            // redirect to list view 
            if (deleteHoopResponse.success) {
                navigate(`/system/managehoops`);
            }

        },
        {
            translationPrefix: "managehoops.actions.delete",

        }
    );

    /**
     * make sure button should show only for version 2 hoops
     */
    const MoreActions = (
        <Menu>
            {hoop?.version === 2 && (
                <Menu.Item
                    key="more-actions-delete"
                    onClick={async () => { await confirmDeleteHoop() }}
                    icon={<DeleteIcon />}
                >
                    {t("managehoops.actions.delete.button.title")}
                </Menu.Item>
            )}


        </Menu >
    );

    return (
        <Dropdown
            overlay={MoreActions}
            trigger={["click"]}
            placement="bottomRight"
            arrow
        >
            <Button
                key="hoop-more-actions"
                icon={<MoreIcon />}
                data-cy-id="hoop-more-actions"
            />
        </Dropdown>
    );
};
